module.exports = __webpack_public_path__ + "static/media/wt1.106523a9.png";